import { useEffect, useState } from 'react';
import { PENDING_EVENT, PENDING_KEY, readPending } from '../utils/tomPayments';

/** The stored, not-yet-recorded Tap on Mobile approvals; follows changes in this tab and others. */
export default function usePendingTomPayments() {
  const [list, setList] = useState(readPending);
  useEffect(() => {
    const refresh = () => setList(readPending());
    const onStorage = (e) => {
      if (!e.key || e.key === PENDING_KEY) refresh();
    };
    window.addEventListener(PENDING_EVENT, refresh);
    window.addEventListener('storage', onStorage);
    refresh();
    return () => {
      window.removeEventListener(PENDING_EVENT, refresh);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  return list;
}
